import { ErrorBoundary } from '@/components/ui/ErrorBoundary'
import StatusCard from '@/pages/dashboard/widgets/StatusCard'
import MonthToDateCard from '@/pages/dashboard/widgets/MonthToDateCard'
import AvailableToSpendCard from '@/pages/dashboard/widgets/AvailableToSpendCard'

/**
 * The strip above the dashboard grid — "am I OK?", "how is this month
 * tracking?" and "what can I spend?", the three things read first.
 *
 * One bordered card split by dividers rather than three separate cards: the
 * three answers belong to the same glance. Each section still owns its own
 * query and ErrorBoundary, so a failing endpoint blanks its own cell and
 * leaves the other two standing.
 *
 * Columns: three across from 1200px, Status + month-to-date paired with funds
 * full width at tablet, stacked below that.
 */
export default function DashboardBanner() {
  return (
    <div className="grid grid-cols-1 overflow-hidden rounded-[14px] border border-light bg-white tablet:grid-cols-2 desktop:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)_minmax(0,1.3fr)]">
      <div className="min-w-0">
        <ErrorBoundary>
          <StatusCard />
        </ErrorBoundary>
      </div>

      <div className="min-w-0 border-t border-light tablet:border-l tablet:border-t-0">
        <ErrorBoundary>
          <MonthToDateCard />
        </ErrorBoundary>
      </div>

      <div className="min-w-0 border-t border-light tablet:col-span-2 desktop:col-span-1 desktop:border-l desktop:border-t-0">
        <ErrorBoundary>
          <AvailableToSpendCard />
        </ErrorBoundary>
      </div>
    </div>
  )
}
